import {Injectable, signal} from '@angular/core';
import {IPaymentRequestResponse} from '../_types/types';

@Injectable({
  providedIn: 'root',
})
export class CheckoutStoreService {
  private readonly currentPayment = signal<IPaymentRequestResponse | null>(
    null,
  );
  private readonly paymentsRealizedInThisSession = signal<IPaymentRequestResponse[]>([]);
  private readonly _cajaId = signal<number | null>(null);

  constructor() {
  }

  set payment(value: IPaymentRequestResponse) {
    if (this.currentPayment()?.qr_data === value.qr_data) {
      this.paymentsRealizedInThisSession.update((actualList) => [...actualList, value]);
    } else {
      this.paymentsRealizedInThisSession.set([value]);
    }
    this.currentPayment.set(value);
  }

  get payment(): IPaymentRequestResponse | null {
    return this.currentPayment();
  }

  get paymentList(): IPaymentRequestResponse[] {
    return this.paymentsRealizedInThisSession();
  }

  get ccId() {
    return this._cajaId() ?? 0;
  }

  set ccId(value: number) {
    this._cajaId.set(value);
  }
}
